<h2>Form Controls</h2>
<p class="demo-description">Demonstrates <code>upp-input</code>, <code>upp-textarea</code>, and <code>upp-search</code>.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleReadonly()">Readonly: {{ isReadonly }}</ion-button>
    <ion-button size="small" (click)="toggleDisabled()">Disabled: {{ isDisabled }}</ion-button>
    <ion-button size="small" color="warning" (click)="markAllTouched()">Show Errors</ion-button>
    <ion-button size="small" color="medium" (click)="resetForm()">Reset</ion-button>
</div>

<!-- upp-input demos -->
<div class="demo-section" [formGroup]="form">
    <h3>upp-input</h3>

    <ion-list lines="none">
        <ion-item>
            <upp-input
                formControlName="textField"
                placeholder="Enter text..."
                title="Text (required, min 3 chars)"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-input>
        </ion-item>

        <ion-item>
            <upp-input
                formControlName="emailField"
                placeholder="user@example.com"
                title="Email"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-input>
        </ion-item>

        <ion-item>
            <upp-input
                formControlName="passwordField"
                placeholder="Enter password..."
                title="Password"
                type="password"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-input>
        </ion-item>

        <ion-item>
            <upp-input
                formControlName="numberField"
                placeholder="0.00"
                title="Number"
                type="number"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-input>
        </ion-item>
    </ion-list>
</div>

<!-- upp-textarea demo -->
<div class="demo-section" [formGroup]="form">
    <h3>upp-textarea</h3>
    <ion-list lines="none">
        <ion-item>
            <upp-textarea
                formControlName="textareaField"
                placeholder="Type something longer..."
                title="Textarea (required)"
                [rows]="3"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-textarea>
        </ion-item>
    </ion-list>
</div>

<!-- upp-search demo -->
<div class="demo-section">
    <h3>upp-search</h3>
    <div class="demo-field">
        <label class="demo-label">Search (value: {{ searchValue || 'null' }})</label>
        <upp-search
            placeholder="Search products..."
            [kiosk]="false"
            (Changed)="onSearchChanged($event)">
        </upp-search>
    </div>
</div>
